import Vuex from "vuex";
import ThemeModule from "./store/theme.js";
import UserModule from "./store/user.js";
import MessageModule from "./store/message.js";
import * as store from "./namespaceStore.js";

export default new Vuex.Store({
    modules: {
        [store.THEME]: ThemeModule,
        [store.USER]: UserModule,
        [store.MESSAGE]: MessageModule
    }
});
